import {  BaseClient, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { DeviceQuestionnaireResponseDto, DeviceQuestionnairesGridDto, } from "../../dto";
export class QuestionnaireResponseClient extends BaseClient {
    routes = ["pophub", "Device"];

    async getQuestionnaireResponseAsync(id: string | undefined): Promise<DeviceQuestionnaireResponseDto[]> {
        const actions: string[] = ["GetQuestionnaireResponse"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];
        const result: DeviceQuestionnaireResponseDto[] = await this.getAsync<DeviceQuestionnaireResponseDto[]>(actions, params);
        return result;
    }

    async searchQuestionnaireResponsesAsync(
        id: string | undefined
    ): Promise<IPagedResult<DeviceQuestionnairesGridDto>> {
        const actions: string[] = ["SearchDeviceQuestionnaires"];
        const params: ApiParams[] = [new ApiParams("questionnaireId", id, true)];

        const result: IPagedResult<DeviceQuestionnairesGridDto> = await this.getAsync<IPagedResult<DeviceQuestionnairesGridDto>
        >(actions, params);
        return result;
    }
}

